import { render, staticRenderFns } from "./BBPayOrderStatusHeader.vue?vue&type=template&id=078e9e10&scoped=true"
import script from "./BBPayOrderStatusHeader.vue?vue&type=script&lang=js"
export * from "./BBPayOrderStatusHeader.vue?vue&type=script&lang=js"
import style0 from "./BBPayOrderStatusHeader.vue?vue&type=style&index=0&id=078e9e10&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "078e9e10",
  null
  
)

export default component.exports